module.exports = __webpack_public_path__ + "static/media/apple-store-badge.8c15379d.svg";